import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=745f4430"
import script from "./CategoryFilters.vue?vue&type=script&lang=js"
export * from "./CategoryFilters.vue?vue&type=script&lang=js"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=745f4430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports